__turbopack_context__.v({
  "badgeButton": "badgeButton-module-scss-module__RNDeja__badgeButton",
  "badgeButtonActive": "badgeButton-module-scss-module__RNDeja__badgeButtonActive",
  "badgeButtonDisabled": "badgeButton-module-scss-module__RNDeja__badgeButtonDisabled",
  "badgeButtonLoading": "badgeButton-module-scss-module__RNDeja__badgeButtonLoading",
  "badgeButtonTooltip": "badgeButton-module-scss-module__RNDeja__badgeButtonTooltip",
  "iconLock": "badgeButton-module-scss-module__RNDeja__iconLock",
  "pulse": "badgeButton-module-scss-module__RNDeja__pulse",
});
